import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MakingDataService } from './md/service/making-data.service';
import { TokenService } from './token.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  login_with_password = environment.loginWithPassword || false;

  apiHost = environment.apiHost || "https://localhost"
  apiPort = environment.apiPort || "3006"
  version = "22-05-2021";
  httpUrl: any;
  profile_data = '';
  uiHost = environment.apiHost || "https://localhost"
  apiProtocol: any
  constructor(private http: HttpClient, private token: TokenService, private mds: MakingDataService) {
    this.uiHost = window.location.hostname;
    ////////////////////////////
    // decide protocol based on window location
    if (this.uiHost === "localhost") {
      this.apiProtocol = "http";

    }
    else {

      this.apiProtocol = "https";
    }



    if (this.uiHost.startsWith("dev.erp2.upda.co.in")) {
      this.uiHost = 'dev.erp2.upda.co.in';

    } else if (this.uiHost.startsWith("newerp.upneda.co")) {
      this.uiHost = 'newerp.upneda.co';
      this.apiPort = '3046';
      this.login_with_password = true;
    } else if (this.uiHost.startsWith("admin.dev.upnn.co.in")) {
      this.uiHost = 'development.upnn.co.in';
      this.apiPort = '3042';
      this.login_with_password = true;
    } else if (this.uiHost.startsWith("erp.upnn.co.in")) {
      this.uiHost = 'lucknow.upnn.co.in';
      this.apiPort = '3038';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("noc.admin.upnn.co.in")) {
      this.uiHost = 'noc.public.upnn.co.in';
      this.apiPort = '3010';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("jhansi.upda.co.in")) {
      this.uiHost = 'property.jda.upda.co.in';
      this.apiPort = '3016';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("petadmin.testing.upnn.co.in")) {
      this.uiHost = 'petpublic.testing.upnn.co.in';
      this.apiPort = '3011';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("noc.testing.upnn.co.in")) {
      this.uiHost = 'nocpublic.testing.upnn.co.in';
      this.apiPort = '3012';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("streetvendor.testing.upnn.co.in")) {
      this.uiHost = 'streetpublic.testing.upnn.co.in';
      this.apiPort = '3013';
      this.login_with_password = false;
    } else if (this.uiHost.startsWith("lda.property.upda.co.in")) {
      this.uiHost = 'lda.property.upda.co.in';
      this.apiPort = '3020';
      this.login_with_password = true;
    }
    else {

      this.uiHost = 'localhost';


      // this.uiHost='icds.upda.co.in';
      // this.apiPort = '3009';
      // this.apiProtocol = "https";

    }
    this.httpUrl = this.apiProtocol + '://' + this.uiHost + ":" + this.apiPort;
    console.log("API @ " + this.httpUrl + " is being used.");
  }

  allLanguage: any = []
  allLableShowObj: any = {};
  allLabel: any = [];
  language_cd: any;
  allLableShowObjProp: any = {};
  allLabelProp: any = [];
  allLableShowObjHR: any = {};
  allLabelHR: any = [];
  allLableShowObjSA: any = {};
  allLabelSA: any = [];
  allSystemModuleObj: any = {};
  changeLanguage() {
    if (this.language_cd == null || this.language_cd == undefined) {
      this.language_cd = 'ENG'
    }
  }

  async getSystemModule() {
    let obj: any = new Object();
    obj['b_acct_id'] = 0;
    var resp = await this.getModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      obj = new Object();
      for (let i = 0; i < resp.data.length; i++) {
        obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      }
      this.allSystemModuleObj = obj;

    } else {

    }
  }
  async signUp(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/signup', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }



  async login(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/login', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getAllLanguages(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getAllLanguages' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getAssignModules(b_acct_id: any, role_cd: any) {
    let obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var resp = await this.getAllAssignModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      //  obj = new Object();
      // for (let i = 0; i < resp.data.length; i++) {
      //   obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      // }
      // this.allSystemModuleObj = obj;
      console.log(resp.data)
      return resp.data
    } else {
      return []
    }
  }




  async getAllAssignModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/resource/getAssignModules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getcomponentLabelvalueswithLanguage(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  // async getcomponentLabelvalueswithLanguage1(obj) {
  //   const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage1' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return res;
  // }

  async send_message(obj: any) {
    console.log(obj)
    const resp = this.http.post<any>(this.httpUrl + '/systemdata/authentication/send_msg_OTP', this.mds.dataE(obj),
      {
        headers:
          new HttpHeaders().append('token', await
            this.mds.tokenData()).append('session',
              this.mds.session)
      }).toPromise().then(res => {
        return this.mds.dataD(res)
      });
    return resp
  }

  async msg_verify_OTP(obj: any) {
    //  obj['gateway_id'] = this.auth_gateway_id
    const resp = this.http.post<any>(this.httpUrl + '/systemdata/authentication/msg_verify_OTP', this.mds.dataE(obj), {
      headers:
        new HttpHeaders().append('token', await
          this.mds.tokenData()).append('session',
            this.mds.session)
    }).toPromise().then(res => {
      return this.mds.dataD(res)
    });
    return resp
  }

  async getaccountmodule(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/legalentity/getaccountmodule' + JSON.stringify({}), { headers: new HttpHeaders().append('token', await this.token.token).append('session', this.token.session).append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }

  async getCurrentrole(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/role/getcurrentroles' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentroleForAccount(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj).toPromise().then(res => {
      return res
    });
    return resp;
  }

  async getCurrentUserFromAdmin(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/user/getcurrentuser' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentUserFromMD(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/user/getcurrentuser' + JSON.stringify({}),
      { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
        return await this.mds.dataD(res);
      });
    return resp;
  }

  async loginToAll(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/loginToAll', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async verifyLoginToAll(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/verifyLoginToAll', this.mds.dataE(obj), { headers: new HttpHeaders().append('token', await this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async updateSession(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/updateSession', this.mds.dataE(obj), { headers: new HttpHeaders().append('token', await this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async getErpUser(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/getErpUser', this.mds.dataE(obj), { headers: new HttpHeaders().append('token', await this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async loginERP(obj: any) {
    console.log(obj)
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/login', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    console.log(resp)
    return resp;
  }

  async createloginInfo(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/loginInfo/createloginInfo', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getDataFromMobileNumberOrEmail(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getDataFromMobileNumberOrEmail' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
